export const communitiesListCollection = ({ userCommunities }) => {
    return userCommunities.map((item) => {
        return {
            id: item.id,
            name: item.name
        };
    });
};
